module.exports = __webpack_public_path__ + "static/media/heritage-quality.fbf288e3.png";